// Shared design tokens for the /demo "Servotech One" experience.
// Kept separate from the main app theme so nothing here can affect existing pages.

export const API_BASE = "https://api.servotechsolar.in";

export const demo = {
  // backdrop
  bg: "#070b14",
  bgGradient:
    "radial-gradient(1200px 600px at 12% -10%, rgba(56,130,246,0.18), transparent 60%)," +
    "radial-gradient(900px 500px at 100% 0%, rgba(34,211,238,0.14), transparent 55%)," +
    "linear-gradient(180deg, #070b14 0%, #0a0f1c 100%)",
  // surfaces
  surface: "rgba(255,255,255,0.04)",
  surfaceHover: "rgba(255,255,255,0.07)",
  border: "rgba(255,255,255,0.10)",
  borderStrong: "rgba(255,255,255,0.18)",
  // brand
  primary: "#3b82f6",
  primaryDeep: "#2563eb",
  accent: "#22d3ee",
  green: "#34d399",
  amber: "#fbbf24",
  // text
  text: "#e8eef8",
  textDim: "#93a1b5",
  textFaint: "#5f6b7e",
};

export const glassCard = {
  background: demo.surface,
  border: `1px solid ${demo.border}`,
  borderRadius: "18px",
  backdropFilter: "blur(12px)",
  WebkitBackdropFilter: "blur(12px)",
};
